import React from "react";
import {
	CircularProgress,
	LinearProgress,
	makeStyles,
	Grid,
} from "@material-ui/core";

interface ProgressIndicatorProps {
	type?: "circular" | "linear";
	color?: "primary" | "secondary";
	size?: number;
	wrapperHeight?: string | number;
}

const useStyles = makeStyles(() => ({
	indicatorContainer: {
		justifyContent: "center",
		alignContent: "center",
	},
	containerHeight: {
		height: "-webkit-fill-available",
	},
}));

const ProgressIndicator = (props: ProgressIndicatorProps) => {
	const classes = useStyles();
	const { type, color, size, wrapperHeight } = props;

	if (type === "linear") {
		return <LinearProgress color={color} />;
	}

	return (
		<Grid
			container
			className={classes.indicatorContainer}
			style={wrapperHeight ? { height: wrapperHeight } : {}}
		>
			<Grid item>
				<CircularProgress
					color={color}
					style={{ width: size ? size : 112, height: size ? size : 112 }}
				/>
			</Grid>
		</Grid>
	);
};

export default ProgressIndicator;
